/******************************************************************************************
 *	Reseller Change Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.resellerChangeModal', [])
    .factory(
      'ResellerChangeModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/reseller-change-modal.html',
          controller: 'ResellerChangeModalController',
          classNames: 'reseller-change-modal'
        });
      }
    )
    .controller('ResellerChangeModalController', resellerChangeModalController);

  //NOSONAR
  function resellerChangeModalController(
    _,
    $log,
    $scope,
    ResellerChangeModal,
    CurtainNotifications,
    Reseller,
    Utility
  ) {

    // Modal Title
    $scope.modalTitle = 'resellerChangeModal.title';

    // Modal Title
    $scope.formSubmitLabel = 'resellerChangeModal.submit';

    $scope.submitted = false;
    $scope.emailIsInvalid = true;


    $scope.email = '';
    $scope.vipNumber = '';

    $scope.emailChange = function () {
      if ($scope.email) {
        const isFirstCharInvalid = /[!+=/\-@|]/.test($scope.email.slice(0,1));
        if (isFirstCharInvalid) {
          $scope.email = $scope.email.slice(1);
        }
      }

      $scope.emailIsInvalid = !Utility.isValidEmail($scope.email);
    };

    $scope.vipNumberChange = function () {
      if ($scope.vipNumber) {
        const isFirstCharInvalid = /[!+=/\-@|]/.test($scope.vipNumber.slice(0,1));
        if (isFirstCharInvalid) {
          $scope.vipNumber = $scope.vipNumber.slice(1);
        }
      }
    };

    // Close modal
    $scope.removeModal = function() {
      ResellerChangeModal.remove({cancelled: true});
    };

    $scope.submit = function() {
      if (!$scope.submitted) {
        ResellerChangeModal.setLoadingState();
        $scope.submitAttempted = true;

        $scope.submitted = true;

        // request payload: { VIPNumber: string; email: string };
        Reseller.resellerChange({VIPNumber: $scope.vipNumber, email: $scope.email}).then(function(responseData) {
          CurtainNotifications.show(CurtainNotifications.SUCCESS,
            'resellerChangeModal.notifications.submitSuccess', {
            email: $scope.email
          });

          ResellerChangeModal.remove({response: responseData});
        }).catch(function(response) {
          ResellerChangeModal.unsetLoadingState();
          $log.warn(response.data, response.status);

          let errorMessage = 'resellerChangeModal.notifications.serviceFailure';
          if(response.data.errorCode === 'INVALID_CUSTOMER_DATA'){
            errorMessage = 'resellerChangeModal.notifications.validationError';
          } else if(response.data.errorCode === 'THROTTLING'){
            errorMessage = 'resellerChangeModal.notifications.dailyRetryError';
          }
          CurtainNotifications.show(CurtainNotifications.ERROR, errorMessage);

          ResellerChangeModal.remove({refreshCustomers: true});
        });
      }
    };
  }
})();
